import "../main.css";

export default function PalavraChavePsicografica() {
  return (
    <div>
      <ul
        className="nav categories-nav nav-pills flex-column"
        role="navigation"
      >
        <li className="nav-item open">
          <h3>Palavras-chave</h3>

          <ul className="nav nav-pills flex-column">
            <li className="keypass-container">
              <a className=" keypass" href="/variaveis-psicograficas#segmento">
                segmento
              </a>
              <a
                className="keypass"
                href="/variaveis-psicograficas#neuroticismo"
              >
                neuroticismo
              </a>
              <a
                className="keypass"
                href="/variaveis-psicograficas#experiencia"
              >
                abertura à experiência
              </a>
              <a
                className="keypass"
                href="/variaveis-psicograficas#extroversao"
              >
                extroversão
              </a>
              <a
                className="keypass"
                href="/variaveis-psicograficas#custobeneficio"
              >
                custo benefício
              </a>
              <a
                className="keypass"
                href="/variaveis-psicograficas#consumoonline"
              >
                consumo on-line
              </a>
              <a
                className="keypass"
                href="/variaveis-psicograficas#estabilidade"
              >
                estabilidade
              </a>
              <a
                className="keypass"
                href="/variaveis-psicograficas#statussocial"
              >
                status social
              </a>
              <a
                className="keypass"
                href="/variaveis-psicograficas#experienciacompra"
              >
                experiência de compra
              </a>
              <a
                className="keypass"
                href="/variaveis-psicograficas#facilidadepagamento"
              >
                facilidade de pagamento
              </a>
              <a
                className="keypass"
                href="/variaveis-psicograficas#conveniencia"
              >
                conveniência
              </a>
              <a className="keypass" href="/variaveis-psicograficas#premium">
                premium
              </a>
              <a className="keypass" href="/variaveis-psicograficas#varejo">
                varejo físico
              </a>
              <a
                className="keypass"
                href="/variaveis-psicograficas#consumodigital"
              >
                consumo digital
              </a>
              <a
                className="keypass"
                href="/variaveis-psicograficas#premiumservico"
              >
                premium serviço
              </a>
              <a className="keypass" href="/variaveis-psicograficas#esg">
                esg
              </a>
              <a
                className="keypass"
                href="/variaveis-psicograficas#consumooffline"
              >
                consumo off-line
              </a>
              <a
                className="keypass"
                href="/variaveis-psicograficas#conscienciosidade"
              >
                conscienciosidade
              </a>
              <a className="keypass" href="/variaveis-psicograficas#brinde">
                brinde
              </a>
              <a
                className="keypass"
                href="/variaveis-psicograficas#instabilidade"
              >
                instabilidade
              </a>
              <a
                className="keypass"
                href="/variaveis-psicograficas#opçãopagamento"
              >
                opção de pagamento
              </a>
              <a
                className="keypass"
                href="/variaveis-psicograficas#vantagemeco"
              >
                vantagem econômica
              </a>
              <a className="keypass" href="/variaveis-psicograficas#sazonal">
                valor sazonal
              </a>
              <a className="keypass" href="/variaveis-psicograficas#inovacao">
                inovação
              </a>
              <a
                className="keypass"
                href="/variaveis-psicograficas#confiacamarca"
              >
                confiança de marca
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  );
}
